var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qr-code-form"},[_c('div',{attrs:{"id":"login_container"}}),_c('span',[_vm._v("请使用飞书扫码登录 "),_c('a',{on:{"click":_vm.onBack}},[_vm._v("返回")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }